import request from '@/utils/request'

// 集团角色列表
export function roleList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/tenant/list',
    method: 'POST',
    data,
  })
}

// 删除集团角色
export function roleDel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/tenant/delete',
    method: 'POST',
    data,
  })
}

// 新增集团角色
export function roleAddEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/tenant/add',
    method: 'POST',
    data,
  })
}

// 修改集团角色
export function roleUpdate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/rbac/role/tenant/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 查询可以配置的角色权限
 * @apiUrl /user/resource/optionalTree
 */
export function getOptionalTree(data = {}) {
  // return Promise.resolve({
  //   data: resource
  // })
  return request({
    url: '/admin/v1/vehicle/user/resource/optionalTree',
    method: 'post',
    data,
  })
}


// 用户列表
export function userList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/listStaff',
    method: 'POST',
    data,
  })
}

// 新建用户
export function userAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/addStaff',
    method: 'POST',
    data,
  })
}

// 编辑用户
export function userEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/editStaff',
    method: 'POST',
    data,
  })
}

// 启用、禁用账户
export function userUpdateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/updateState',
    method: 'POST',
    data,
  })
}

// 删除账户
export function userDelete(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/deleteStaff',
    method: 'POST',
    data,
  })
}

// 修改密码
export function resetPassword(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/tenant/resetPassword',
    method: 'POST',
    data,
  })
}


// 通过手机号查看绑定关系
export function isRelatedQuery(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/queryOrganization',
    method: 'POST',
    data,
  })
}

// 禁用账户是否是审批人查询
export function isAuditor(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/manage/isApprover',
    method: 'POST',
    data,
  })
}
